import { render, staticRenderFns } from "./AppointmentActivity.vue?vue&type=template&id=19efd0fc&"
import script from "./AppointmentActivity.vue?vue&type=script&lang=js&"
export * from "./AppointmentActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports